import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';

// Shown when someone asks to turn desktop notifications on but the browser has
// already recorded a Block for this site.
//
// This exists because a denial is final as far as the page is concerned:
// Notification.requestPermission() resolves 'denied' immediately from then on,
// without showing anything. A menu item that silently did nothing would look
// broken, so say what happened and where the setting actually lives.
//
// Styled inline, like everything else that might end up in a detached window.
export class NotificationsHelpDialog extends Component {
    render() {
        if (!this.props.open) {
            return null;
        }

        return (
            <Dialog
                open={true}
                onClose={this.props.onDismiss}
                aria-labelledby="notifications-blocked-title"
            >
                <DialogTitle id="notifications-blocked-title" disableTypography>
                    <Typography variant="title" style={{ fontWeight: 600 }}>
                        Notifications are blocked for TeamX
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography style={{ marginBottom: '12px' }}>
                        This browser has notifications blocked for TeamX, and a site
                        cannot ask again once that has been set. It has to be changed
                        in the browser.
                    </Typography>
                    <Typography variant="caption">
                        Chrome and Edge: click the icon at the left of the address bar,
                        find Notifications, and set it to Allow. Firefox: click the
                        same icon and clear the blocked Receive Notifications setting.
                        Then reload TeamX.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onDismiss} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

NotificationsHelpDialog.propTypes = {
    open: PropTypes.bool,
    onDismiss: PropTypes.func.isRequired,
};

export default NotificationsHelpDialog;



// WEBPACK FOOTER //
// ./src/components/NotificationsHelpDialog.js